export default [
  {
    name: 'custom_header_universiteitantwerpen',
    path: 'modules/pages/universiteitantwerpen/HeaderUniversiteitantwerpen'
  }
]
